import { Pipe } from '@angular/core'
import { isChildRental, isMainUnit, isParentRental, isSubunit } from './rental.models'

@Pipe({
  name: 'isMainUnit',
})
export class IsMainUnitPipe {
  transform(rental: any): boolean {
    return isMainUnit(rental)
  }
}

@Pipe({
  name: 'isSubunit',
})
export class IsSubunitPipe {
  transform(rental: any): boolean {
    return isSubunit(rental)
  }
}

@Pipe({
  name: 'isParentRental',
})
export class IsParentRentalPipe {
  transform(rental: any): boolean {
    return isParentRental(rental)
  }
}

@Pipe({
  name: 'isChildRental',
})
export class IsChildRentalPipe {
  transform(rental: any): boolean {
    return isChildRental(rental)
  }
}
